import { FC } from 'react';
import { useTypedDispatch } from '../../../redux/hooks/hooks';
import { FormikProvider, useFormik } from 'formik';
import { emailSchema } from '../../../common/schemas/emailSchema';
import { verifyEmail } from '../../../redux/user/userOperations';
import { ModalYellowGradient } from '../SharedComponent/ModalYellowGradient/ModalYellowGradient';
import { CloseButton } from '../SharedComponent/CloseButton/CloseButton';
import { Field } from '../SharedComponent/TextField/TextField';
import { Btn, StyledForm, Text, Wrapper } from './ModalVerifyEmail.styled';

type Props = {
  isModalVerifyEmailOpen: boolean;
  handleCloseVerifyEmailModal: () => void;
  handleCloseSignUpSignInModal: () => void;
};

type FormValues = {
  email: string;
};

export const ModalVerifyEmail: FC<Props> = ({
  isModalVerifyEmailOpen,
  handleCloseVerifyEmailModal,
  handleCloseSignUpSignInModal,
}) => {
  const dispatch = useTypedDispatch();

  const formik = useFormik({
    initialValues: {
      email: '',
    },
    validationSchema: emailSchema,
    onSubmit: (values: FormValues, _) => {
      dispatch(verifyEmail(values)).then(result => {
        if (result.meta.requestStatus === 'fulfilled') {
          handleCloseSignUpSignInModal();
        }
      });
    },
  });
  return (
    <>
      <ModalYellowGradient
        isModalOpen={isModalVerifyEmailOpen}
        handleCloseModal={handleCloseVerifyEmailModal}
      >
        <CloseButton handleCloseModal={handleCloseVerifyEmailModal} />
        <Wrapper>
          <Text>Ваша е-пошта не верифікована.</Text>
          <Text>Введіть е-пошту для повторної верифікації.</Text>
          <FormikProvider value={formik as any}>
          <StyledForm onSubmit={formik.handleSubmit}>
            <Field
              id="email"
              name="email"
              label="E-пошта"
              type="text"
              value={formik.values.email}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={formik.touched.email && Boolean(formik.errors.email)}
              helperText={formik.touched.email && formik.errors.email}
            />
            <Btn type="submit">
              <div>Відправити</div>
            </Btn>
          </StyledForm>
          </FormikProvider>
        </Wrapper>
      </ModalYellowGradient>
    </>
  );
};
